// extracted by mini-css-extract-plugin
module.exports = {"ol":"RichOrderedList_ol__lkkc4","withSpace":"RichOrderedList_withSpace__2E3GZ"};